import { type Component, Index } from 'solid-js'

import { Field, Select, createListCollection } from '@components'
import { useService } from 'solid-services'
import { ChevronDownIcon } from 'lucide-solid'
import { type Sort, useFilters } from '../state/filter'
import { LastSelectDisabled } from './LastSelectDisabled'

export const NewSort: Component = () => {
	const { filters, setSort } = useService(useFilters)()

	const collection = createListCollection({
		items: [
			'recent-activity',
			'recently-submitted',
			'subscribers',
			'takers',
			'PHQ',
			'community-score',
		] as Sort[],
	})

	const selected = () => filters().sort

	return (
		<Field.Root>
			<Field.Label>Sort</Field.Label>
			<Select.Root
				positioning={{
					sameWidth: true,
				}}
				value={[selected()]}
				collection={collection}
				onValueChange={({ value }) => {
					setSort(value[0] as Sort)
				}}
			>
				<Select.Control>
					<Select.Trigger>
						<Select.ValueText />
						<Select.Indicator>
							<ChevronDownIcon />
						</Select.Indicator>
					</Select.Trigger>
				</Select.Control>
				<Select.Positioner>
					<Select.Content>
						<Select.ItemGroup>
							<Index each={collection.items}>
								{(item) => (
									<LastSelectDisabled
										item={item()}
										selected={[selected()]}
									/>
								)}
							</Index>
						</Select.ItemGroup>
					</Select.Content>
				</Select.Positioner>
				<Select.HiddenSelect />
			</Select.Root>
		</Field.Root>
	)
}
